import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    // Check for saved user in localStorage with better error handling
    try {
      const savedUser = localStorage.getItem('vrWorldUser');
      if (savedUser && savedUser !== 'undefined' && savedUser.trim() !== '') {
        try {
          const parsedUser = JSON.parse(savedUser);
          if (parsedUser && typeof parsedUser === 'object') {
            setUser(parsedUser);
          } else {
            // Invalid user object, remove it
            localStorage.removeItem('vrWorldUser');
          }
        } catch (error) {
          console.error('Error parsing saved user:', error);
          // Clear the invalid data
          localStorage.removeItem('vrWorldUser');
        }
      }
    } catch (e) {
      console.error('Error accessing localStorage:', e);
    } finally {
      setLoading(false);
    }
  }, []);
  
  // Register new user
  const register = async (username) => {
    try {
      const response = await fetch('/api/users/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username }),
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.error || 'Failed to register');
      }
      
      setUser(data);
      
      try {
        localStorage.setItem('vrWorldUser', JSON.stringify(data));
      } catch (e) {
        console.error('Error saving to localStorage:', e);
      }
      
      return data;
    } catch (error) {
      console.error('Registration error:', error);
      throw error;
    }
  };
  
  // Logout
  const logout = () => {
    setUser(null);
    try {
      localStorage.removeItem('vrWorldUser');
    } catch (e) {
      console.error('Error removing from localStorage:', e);
    }
  };
  
  const value = {
    user,
    register,
    logout,
    loading
  };
  
  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
} 